function startApp() {
    import('init').catch((err) => {
        // TODO handle this error.
        console.error(err);
    });
}

if (process.env.REACT_APP_IS_CORDOVA === 'true') {
    document.addEventListener(
        'deviceready',
        () => {
            startApp();
        },
        false
    );
} else {
    startApp();
}
